import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AdminChallengeContent, Challenge, ChallengeType } from '../../services/models/challenges.model';
import { Router } from '@angular/router';
import { SearchModel } from '../../../models/search-model';

@Component({
  selector: 'app-challenges-admin-card',
  templateUrl: './challenges-admin-card.component.html',
  styleUrls: ['./challenges-admin-card.component.scss']
})
export class ChallengesAdminCardComponent {

  @Input() challenge!: Challenge<AdminChallengeContent>;
  @Output() viewContents = new EventEmitter<void>();

  constructor(
    private readonly router: Router,
  ) {
  }

  getChallengeCreatedByLabel(): string {
    return this.challenge.isPublic ? 'user.challenges.createdByAdmin' : 'user.challenges.createdByAdminPrivate';
  }

  getChallengeProgressTitleLabel(): string {
    switch (this.challenge.type) {
      case ChallengeType.TITLES_READ_CHALLENGE:
      case ChallengeType.CHECKOUT_TITLES_CHALLENGE:
        return 'user.challenges.consumedContent';
      case ChallengeType.READING_TIME_CHALLENGE:
        return 'general.pluralHour';
      default:
        return '';
    }
  }

  showContents() {
    const searchModel = new SearchModel();

    this.router.navigate(['/results'], {
      queryParams: {
        ...searchModel.toRequest(),
        title: this.challenge.name,
        showReturnButton: true,
        hideButtonsSideMenu: true,
        originPage: '/user/challenges',
        challengeId: this.challenge.id,
      },
    });
  }
}
